import { useMutation } from '@tanstack/react-query';

import { createRequestPlanInput } from '../services';

export function useCreateRequestPlanInput() {
  return useMutation({
    mutationFn: createRequestPlanInput,
  });
}
